var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject } from '../../../Data/Decorators/Inject';
import { injectable } from '../../../Data/Decorators/Injectable';
import { reactive } from '../../Decorators/Reactive';
import { IPushNotificationsServiceType } from '../../../Domain/Services/PushNotificationsService/IPushNotificationsService';
let NotificationsPermissionScreenViewModel = class NotificationsPermissionScreenViewModel {
    constructor(pushNotificationsService) {
        this.pushNotificationsService = pushNotificationsService;
        this.viewData = {
            loading: false,
            error: ''
        };
        this.close = this.close.bind(this);
        this.ok = this.ok.bind(this);
        this.dismissError = this.dismissError.bind(this);
    }
    dismissError() {
        this.updateViewData({ error: '' });
    }
    close() {
        this.updateViewData({ loading: true });
        return this.pushNotificationsService.denyPushNotifications()
            .then(() => this.updateViewData({ loading: false }))
            .catch(error => this.updateViewData({ loading: false, error: error.message }));
    }
    ok() {
        this.updateViewData({ loading: true });
        return this.pushNotificationsService.allowPushNotifications()
            .then(() => this.updateViewData({ loading: false }))
            .catch(error => this.updateViewData({ loading: false, error: error.message }));
    }
    cancel() {
        return this.close();
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], NotificationsPermissionScreenViewModel.prototype, "viewData", void 0);
NotificationsPermissionScreenViewModel = __decorate([
    injectable(),
    __param(0, inject(IPushNotificationsServiceType)),
    __metadata("design:paramtypes", [Object])
], NotificationsPermissionScreenViewModel);
export { NotificationsPermissionScreenViewModel };
